export { default } from './part-description';
